import { translate } from '@jsverse/transloco';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {showFeedback, showFeedbackError} from '../core/util/notification';
import {Globals} from '../globals';
import {AppInjector} from '../../app-injector';


export function ServiceErrorHandler(): any {
  return function (target: any, name: string, descriptor: PropertyDescriptor) {
    const method = descriptor.value;
    descriptor.value = function (...args) {
      const call: Observable<any> = method.apply(this, args);
      return call.pipe(
        catchError((e: HttpErrorResponse) => {
          const globals: Globals = AppInjector ? AppInjector.get(Globals) : null;

          let parsedError = e.error;
          if (typeof parsedError === 'string') {
            try { parsedError = JSON.parse(parsedError); } catch (_) {}
          }

          const errorObject = {
            error: e,
            request: globals && globals.lastRequest ? globals.lastRequest : null,
          };

          switch (e.status) {
            case 404:
              if (parsedError && parsedError.message === "Invalid project code.") {
                this.globals.projectCode = null;
              } else if (parsedError?.error?.message === 'external_resource_unavailable') {
                // Silently ignore - external layer resource not reachable
              } else {
                showFeedback(translate('error.not_found'), 'error', errorObject, false);
              }
              break;
            case 401:
                if (parsedError?.error_code === 'SESSION_INVALIDATED' || parsedError?.error_code === 'SESSION_EXPIRED') {
                  break; // Let SessionInvalidationInterceptorService handle these
                }
                showFeedback(translate('error.please_wait'), 'error', errorObject, false);
                this.globals.projectCode = null;
                localStorage.clear();
                window.location.href = '/login';
              break;
            case 403:
              showFeedback(translate('error.contact_administrator'), 'error', errorObject, true);
              break;
            case 504:
              showFeedback(translate('error.server_error'), 'error', errorObject, true);
              break;
            default:
              showFeedbackError(errorObject);
              break;
          }
          return throwError(e);
        })
      );
    };
  };
}
